import { Route } from 'react-router-dom';
import OrderConfirmation from '../pages/OrderConfirmation';
import MyOrders from '../pages/MyOrders';
import OrderDetail from '../pages/OrderDetail';

export const OrderRoutes = () => {
    return (
        <>
            <Route path="/order-confirmation/:id" element={<OrderConfirmation />} />
            <Route path="/my-orders" element={<MyOrders />} />
            <Route path="/my-orders/:id" element={<OrderDetail />} />
        </>
    );
}
